import { ColorblindTheme } from "../.internal/themes/ColorblindTheme";
export default ColorblindTheme;
